import './Tooltip-bab00c98.css';

var classes = {"Tooltip":"prc-TooltipV2-Tooltip-cYMVY","\\":"prc-TooltipV2----ketfx","tooltip-appear":"prc-TooltipV2-tooltip-appear-hLf77","keybindingHintContainer":"prc-TooltipV2-keybindingHintContainer-tv-0S","hasTextBefore":"prc-TooltipV2-hasTextBefore-ot22R"};

export { classes as default };
